import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Lisäaineet',
  options: {
    [ProductAdditives.AcesulfamK]: 'Asesulfaami K',
    [ProductAdditives.AceSucralose]: 'Ase-Sukraloosi',
    [ProductAdditives.Aesculin]: 'Eskuliini',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Antosyaani',
    [ProductAdditives.Antioxidant]: 'Antioksidantti',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioksidantti: Askorbiinihappo',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioksidantti: Tokoferolit',
    [ProductAdditives.Flavor]: 'Aromi',
    [ProductAdditives.Flavors]: 'Aromit',
    [ProductAdditives.AscorbicAcid]: 'Askorbiinihappo',
    [ProductAdditives.Aspartame]: 'Aspartaami',
    [ProductAdditives.OysterSauce]: 'Osterikastike',
    [ProductAdditives.BakingAid]: 'Leivontajauhe-apuaine',
    [ProductAdditives.BakingPowder]: 'Leivinjauhe',
    [ProductAdditives.BalsamicVinegar]: 'Balsamietikka',
    [ProductAdditives.BalsamicCream]: 'Balsamikerma',
    [ProductAdditives.BasilPesto]: 'Basilikapesto',
    [ProductAdditives.BenzoicAcid]: 'Bentsoehappo',
    [ProductAdditives.BetaCarotene]: 'Beetakaroteeni',
    [ProductAdditives.Betain]: 'Betaiini',
    [ProductAdditives.BeetrootRed]: 'Punajuuripunainen',
    [ProductAdditives.Beeswax]: 'Mehiläisvaha',
    [ProductAdditives.Bitters]: 'Bitter',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Blue Curaçao -siirappi',
    [ProductAdditives.BrandyVinegar]: 'Brandyetikka',
    [ProductAdditives.Broth]: 'Liemi',
    [ProductAdditives.Caffeine]: 'Kofeiini',
    [ProductAdditives.Calcium]: 'Kalsium',
    [ProductAdditives.Caramel]: 'Karamelli',
    [ProductAdditives.CaramelColor]: 'Karamelliväri',
    [ProductAdditives.CaramelE150d]: 'Karamelli E150d',
    [ProductAdditives.Carotene]: 'Karoteeni',
    [ProductAdditives.CayennePepper]: 'Cayennepippuri',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Chilikastike',
    [ProductAdditives.ChiliMayonnaise]: 'Chilimajoneesi',
    [ProductAdditives.ChiliOil]: 'Chiliöljy',
    [ProductAdditives.Quinine]: 'Kiniini',
    [ProductAdditives.Chlorophyll]: 'Klorofylli',
    [ProductAdditives.CitricAcid]: 'Sitruunahappo',
    [ProductAdditives.CitrusAcid]: 'Sitrushappo',
    [ProductAdditives.CarbonDioxide]: 'Hiilidioksidi (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Cocktailkastike',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Currytahna',
    [ProductAdditives.CurryPowder]: 'Curryjauhe',
    [ProductAdditives.CurryCreamSauce]: 'Curry-kermakastike',
    [ProductAdditives.Fragrance]: 'Tuoksu',
  },
};
